import { cardHeaderStyles, contentsStyles } from 'app/components/presentation/text/styles';
import { BORDER_RADIUS_B, BOX_SHADOW_A, BOX_SHADOW_C, flexCascade, firefoxPrintHackStyles } from 'app/constants/Styles';
import { useClasses } from 'app/utils/css';
import React, { ReactNode } from 'react';

export type CardPadding = '0' | '15px' | '25px' | '42px' | '42px 0';

interface IProps {
  // Is the component being hovered/focused?
  active?: boolean;
  children: ReactNode;
  header?: ReactNode;
  padding: CardPadding;
}

/**
 * Helper for making cards.
 */
const Card = ({ active = false, children, header, padding }: IProps) => {
  const classes = useClasses({
    card: {
      ...flexCascade,
      backgroundColor: 'white',
      borderRadius: BORDER_RADIUS_B,
      boxShadow: active ? BOX_SHADOW_C : BOX_SHADOW_A,
      padding,
      transition: 'box-shadow 200ms ease-in',
      '@media print': firefoxPrintHackStyles,
    },

    header: {
      margin: '0 0 13px 0',
    },

    cardHeader: cardHeaderStyles,

    content: {
      ...flexCascade,
      ...contentsStyles,
    },
  });

  return (
    <section className={classes.card}>
      {header &&
        <header className={classes.header}>
          <h2 className={classes.cardHeader}>
            {header}
          </h2>
        </header>}

      <div className={classes.content}>
        {children}
      </div>
    </section>
  );
};

export default Card;
